module.exports = __webpack_public_path__ + "static/media/icon_camera.d602aef9.png";